import { EcEnv } from '@castlery/config';

const API_MAP = {
  GET_REVIEW_LIST: `${EcEnv.NEXT_PUBLIC_API_HOST}/gw/reviews/all`,
};

export { API_MAP };
